import React from 'react';
import { Table, Tag } from 'antd';
import moment from 'moment';
import { formatNumberWithCommas } from '../../../utils/numbers';

const LedgerTable = ({ rows, loading }) => {
    const formatPayPeriod = (payPeriod) => {
        const [start, end] = payPeriod.split(' to ');
        const startDate = moment(start, 'DD-MM-YYYY HH:mm:ss');
        const endDate = moment(end, 'DD-MM-YYYY HH:mm:ss');
        return `${startDate.format('MMM Do, YYYY')} - ${endDate.format('MMM Do, YYYY')}`;
    };
    console.log(rows);

    const columns = [
        {
            title: 'Account Number',
            dataIndex: 'account_number',
            key: 'account_number',
            render: (text) => <p>#...{text?.slice(-4)}</p>,
        },
        {
            title: 'Pay Period',
            dataIndex: 'pay_period',
            key: 'pay_period',
            render: (text) => <p>{formatPayPeriod(text)}</p>,
        },
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount',
            render: (text) => <p>${formatNumberWithCommas(text, true)}</p>,
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (text) => <Tag color={text === 'advance' ? 'green' : 'blue'}>{text === 'advance' ? 'Advance' : 'Service Fee'}</Tag>,
        },
    ];

    return <Table dataSource={rows} columns={columns} loading={loading} rowKey="id" pagination={{ pageSize: 15 }} />;
};

export default LedgerTable;
